module.exports = __webpack_public_path__ + "media/images/missing-purple-d981e9f9bc915c660d99d08efdac4349.jpeg";